<template>
  <limitedlayout
   title="Vagas"
    menu="Vagas"
  >
    <div class="row">
      <div class="col-lg-12 col-xs-12 pr-2">
        <div class="block_info_white p-2">
          <div class="row">
            <div class="col-lg-2 col-xs-12">
              <div class="form-group color-dark-purple mb-0">
                <h3>VAGAS</h3>
              </div>
            </div>
            <div class="col-lg-7"></div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-9 pl-0">
              <div class="select nav-tabs mb-2 block_info_white d-flex align-items-center">
                <div
                  class="ml-1 pointer"
                  v-if="total_recruiters > 1"
                  @click="searchMyJobs"
                >
                  <input
                    type="checkbox"
                    v-model="onlyMyJobs"
                    @change="searchJobs"
                  />
                  <span class="label-bold color-black">Ver somente as minhas vagas</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-xs-12 pl-0 pt-1">
              <div
                class="form-group mb-0 has-search d-flex justify-content-end"
                style="margin-left: -3px"
              >
                <div>
                  <span class="color-black fa fa-search ml-2 mt-2 mr-3 form-control-feedback"></span>
                </div>
                <input
                  type="text"
                  v-model="search"
                  v-on:keyup.enter="searchJobs"
                  class="form-control no_border pl-5"
                  style="padding: 0px"
                />
              </div>
              <div>
                <span class="label-bold right color-black">{{amount_applies }} CANDIDATOS | {{ totalJobs }} VAGAS</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-xs-12 d-flex mt-0 pt-0">
        <div class="col-lg-6 col-xs-12"></div>
        <div class="col-lg-6"></div>
      </div>
      <div class="col-lg-12 col-xs-12">
        <div
          class="tab-content"
          id="myTabContent"
        >
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div class="row">
              <div class="col-lg-12">
                <table class="table_jovool">
                  <thead class="headerTable">
                    <tr>
                      <td>
                        VAGA
                        <OrderTable
                          field="title"
                          entity="job"
                        />
                      </td>
                      <td class="center">CANDIDATO(A)S</td>
                      <td class="center">
                        CRIADA EM:
                        <OrderTable
                          field="created_at"
                          entity="job"
                          pre_order="desc"
                        />
                      </td>
                      <td class="center">
                        RECRUTADOR(A)
                        <OrderTable
                          entity="job"
                          field="recruiter_name"
                        />
                      </td>
                      <td class="center">LINK</td>
                    </tr>
                  </thead>
                  <tbody class="position-relative">
                    <tr
                      v-for="job in jobs"
                      :key="job.id"
                      :class="{ 'content-loading': loading }"
                    >
                      <td
                        style="max-width: 400px"
                        class="text-truncate"
                      >
                        <inertia-link :href="`/recruiters/limited_jobs/${job.id}/applies`">
                          <b class="color-grey-primary text-truncate">{{
                            job.title
                          }}</b>
                        </inertia-link>
                        <br />
                        <p
                          style="margin-top: -10px"
                          class="mb-0"
                        >
                          <span class="small-text">{{
                            job.minimum_remuneration
                              | currency("R$ ", 2, {
                                decimalSeparator: ",",
                                thousandsSeparator: ".",
                              })
                          }}</span>
                          <span
                            class="small-text"
                            v-show="job.maximum_remuneration != 0"
                          >|
                            {{
                              job.maximum_remuneration
                                | currency("R$ ", 2, {
                                  decimalSeparator: ",",
                                  thousandsSeparator: ".",
                                })
                            }}</span>
                        </p>
                      </td>
                      <td class="center">
                        <inertia-link :href="`/recruiters/jobs/${job.id}/applies`">
                          <span
                            class="pointer alert_small box-danger"
                            role="alert"
                          >{{ job.reproved }}</span>
                          <span
                            class="pointer alert_small box-primary"
                            role="alert"
                          >{{ job.no_avaliation }}</span>
                          <span
                            class="pointer alert_small box-success"
                            role="alert"
                          >{{ job.process }}</span>
                        </inertia-link>
                      </td>
                      <td class="center color-grey">
                        {{ job.created_at | moment("D/MM/Y") }}
                      </td>
                      <td class="center color-grey">
                        {{ job.recruiter_name }}
                      </td>
                      <td class="center">
                        <span
                          class="pointer color-grey"
                          v-clipboard:copy="job.url"
                          v-clipboard:success="onCopy"
                        >
                          <font-awesome-icon icon="link" />
                        </span>
                      </td>
                    
                    </tr>
                    <div
                      class="center position-absolute loading-gif"
                      :class="{ 'd-none': !loading || firstLoad }"
                    >
                      <img
                        src="/images/loading.gif"
                        alt="loading-gif"
                      />
                    </div>
                  </tbody>
                </table>
                <v-pagination
                  v-model="currentPage"
                  :page-count="pageCount"
                  class="justify-content-center"
                  :class="firstLoad ? 'd-none' : 'd-flex'"
                  :classes="bootstrapPaginationClasses"
                ></v-pagination>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div class="row">
              <div class="col-lg-12">
                <table class="table_jovool">
                  <thead class="headerTable">
                    <tr>
                      <td>
                        TÍTULO DA VAGA
                        <OrderTable
                          entity="job"
                          field="title"
                        />
                      </td>
                      <td class="center">Candidato(a)s</td>
                      <td class="center">
                        DATA DE CRIAÇÃO
                        <OrderTable
                          entity="job"
                          field="created_at"
                        />
                      </td>
                      <td class="center">
                        RECRUTADOR(A)
                        <OrderTable
                          entity="job"
                          field="recruiter_name"
                        />
                      </td>
                      <td class="center">URL</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="job in jobs_deleted"
                      :key="job.id"
                    >
                      <td>
                        <b class="color-grey-primary">{{ job.title }}</b>
                        <br />
                        <p>
                          <span class="small-text">{{
                            job.minimum_remuneration
                              | currency("R$ ", 2, {
                                decimalSeparator: ",",
                                thousandsSeparator: ".",
                              })
                          }}</span>
                          <span
                            class="small-text"
                            v-show="job.maximum_remuneration != 0"
                          >|
                            {{
                              job.maximum_remuneration
                                | currency("R$ ", 2, {
                                  decimalSeparator: ",",
                                  thousandsSeparator: ".",
                                })
                            }}</span>
                        </p>
                      </td>
                      <td class="center">
                        <span
                          class="pointer alert_small alert box-danger"
                          role="alert"
                        >{{ job.reproved }}</span>
                        <span
                          class="pointer alert_small alert box-primary"
                          role="alert"
                        >{{ job.no_avaliation }}</span>
                        <span
                          class="pointer alert_small alert box-success"
                          role="alert"
                        >{{ job.process }}</span>
                      </td>
                      <td class="center color-grey">
                        {{ job.created_at | moment("D/MM/Y") }}
                      </td>
                      <td class="center color-grey">
                        {{ job.recruiter_name }}
                      </td>
                      <td class="center">
                        <span
                          class="pointer color"
                          v-clipboard:copy="job.url"
                          v-clipboard:success="onCopy"
                        >
                          <font-awesome-icon icon="paperclip" />
                        </span>
                      </td>

                      <td class="center color-grey">
                        <div
                          style="margin-right: 10px !important"
                          class="menu_column nav nav-tabs"
                        >
                          <li
                            style="background-color: #f4f4f4 !important"
                            class="nav-item dropdown"
                          >
                            <div
                              class="nav-link"
                              data-toggle="dropdown"
                              role="button"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <font-awesome-icon icon="ellipsis-h" />
                            </div>
                            <div class="dropdown-menu dropdownjob">
                              <div class="dropdown-item pointer">
                                <inertia-link :href="`/recruiters/jobs/${job.id}/edit`">
                                  <p>EDITAR VAGA</p>
                                </inertia-link>
                              </div>
                              <div class="dropdown-item pointer">
                                <inertia-link :href="`/recruiters/jobs/${job.id}/applies`">LISTA CANDIDATO(A)S</inertia-link>
                              </div>
                              <div class="dropdown-item pointer">
                                <inertia-link :href="`/recruiters/jobs/${job.id}/kanban`">Kanban Candidato(a)s</inertia-link>
                              </div>
                            </div>
                          </li>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mb-2">
          <span
            class="pointer alert_small alert box-danger m"
            role="alert"
          >.</span>
          <span>= CANDIDATO(A)S REPROVADOS</span>
        </div>
        <div class="mb-2">
          <span
            class="pointer alert_small alert box-primary"
            role="alert"
          >.</span>
          <span>= CANDIDATO(A)S AGUARDANDO AVALIAÇÃO</span>
        </div>
        <div>
          <span
            class="pointer alert_small alert box-success"
            role="alert"
          >.</span>
          <span>= CANDIDATO(A)S QUE EVOLUÍRAM NO PROCESSO</span>
        </div>
      </div>
    </div>
  </limitedlayout>
</template>

<script>
import OrderTable from "components/OrderTable.vue";
import vPagination from "vue-plain-pagination";
export default {
  props: ["block", "recruiter_id", "total_recruiters", "amount_applies"],
  components: { OrderTable, vPagination },
  data: () => ({
    jobs: [],
    jobs_deleted: [],
    search: "",
    onlyMyJobs: false,
    order: "",
    field: "",
    deleted: false,
    firstLoad: true,
    loading: false,
    totalJobs: 0,
    status: 1,
    currentPage: 1,
    pageCount: 1,
    statusJob: [
      { text: "Cancelada", value: 0 },
      { text: "Ativa", value: 1 },
      { text: "Paralisada", value: 2 },
      { text: "Concluída", value: 3 },
    ],
    bootstrapPaginationClasses: {
      ul: "pagination",
      li: "page-item",
      liActive: "active",
      liDisable: "disabled",
      button: "page-link",
    },
  }),
  watch: {
    currentPage: function () {
      this.searchJobs(false);
    },
  },
  mounted() {
    if (this.block) {
      this.$toast.error("VOCÊ JÁ ATINGIU A COTA MÁXIMA DE VAGA NESSA CONTA");
    }
    eventBus.$on("orderColumnjob", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchJobs();
    });
    this.searchJobs();
  },
  methods: {
    searchMyJobs() {
      this.onlyMyJobs = !this.onlyMyJobs;
      this.searchJobs();
    },
    searchJobs(reset_page = true) {
      let params = {};
      if (reset_page) this.currentPage = 1;
      params["deleted"] = this.deleted;
      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      } else {
        params["order"] = {};
        params["order"]["created_at"] = "desc";
      }
      params["search"] = this.search;
      if (this.search === "") {
        params["search"] = "*";
      }
      if (this.onlyMyJobs != 0) {
        params["my_jobs"] = this.onlyMyJobs;
      }
      if (this.status != "") {
        params["status"] = this.status;
      }

      this.loading = true;
      axios
        .get(`/recruiters/jobs/search/${this.currentPage}`, { params: params })
        .then((response) => {
          if (!this.deleted) {
            this.jobs = response.data.jobs;
            this.totalJobs = response.data.total_jobs;
            this.pageCount = Math.ceil(this.totalJobs / 10);
            this.firstLoad = false;
            this.loading = false;
            return;
          }

          this.jobs_deleted = response.data.jobs;
        });
    },
    onCopy: function (e) {
      this.$toast.success("LINK COPIADO COM SUCESSO");
    },
  },
};
</script>
